import type { OrganizationList } from 'models';
import { Avatar, DetailsCategoryItem } from 'ui';
import { images } from 'common/utils';

type P = {
  organization: OrganizationList;
};

const DetailsOrganization = ({ organization }: P) => (
  <DetailsCategoryItem
    category="organization"
    icon={
      <Avatar
        alt="Organization profile photo"
        fallbackPhoto={images.default.organizationProfilePhoto}
        src={organization.squareLogo ?? organization.profilePhoto}
      />
    }
    name={organization.name}
  />
);

export default DetailsOrganization;
